// 直播间玩法映射（game_type -> 中文名），仅用于下注记录展示
export const GAME_TYPE_MAP: Record<number, string> = {
  3001: '人气对决', 3003: '龙虎PK', 3007: '幸运转盘', 3008: '骰子大作战',
  3025: '人气投票', 3026: '龙虎对战', 3027: '安全互动',
  3028: '幸运大转盘', 3029: '三牌PK', 3030: '三方争霸',
  3031: '五张牛牛', 3032: '色碟互动', 3033: '骰子挑战',
  3034: '鱼虾蟹预测', 3036: '大小预测', 3037: '板块预测',
  3038: '牌九互动', 3039: '鱼虾蟹对战', 3041: '牛牛争霸',
  3042: '骰子欢乐场', 3043: '21点互动', 3045: '鱼虾蟹派对',
  3046: '幸运五张', 3047: '21点对决', 3048: '射门大作战',
  3050: '28点挑战', 3303: '弹珠大比拼',
};
